// ─────────────────────────────────────────────────────────────
// NotificationsApi — fetch wrapper for the st-notifications worker
// All admin routes are authenticated with the Clerk JWT from ClerkAuth.
// Token registration routes on the Expo side are public (no auth).
// ─────────────────────────────────────────────────────────────

import {ClerkAuth} from "../auth/ClerkAuth"

const BASE_URL = "https://api.sundaytriggers.com"

async function reqWrite<T>(path: string, options?: RequestInit): Promise<T> {
    const token = await ClerkAuth.getToken()
    const res = await fetch(`${BASE_URL}${path}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        ...options,
    })
    if (!res.ok) {
        const text = await res.text().catch(() => res.statusText)
        throw new Error(`Notifications API ${res.status}: ${text}`)
    }
    return res.json() as Promise<T>
}

// ── Types ─────────────────────────────────────────────────────

export type NotifStats = {
    tokens: number
    notifications: number
}

export type NotifHistoryItem = {
    id: string
    title: string
    body: string
    image_url: string | null
    link: string | null
    sent_at: string
    recipients_count: number
    status: string
}

export type SendPayload = {
    title: string
    body: string
    image_url: string | null
    link: string | null
}

// ── API ───────────────────────────────────────────────────────

export namespace NotificationsApi {

    export const getStats = (): Promise<NotifStats> =>
        reqWrite<NotifStats>("/notifications/stats")

    export const getHistory = (): Promise<{notifications: NotifHistoryItem[]}> =>
        reqWrite<{notifications: NotifHistoryItem[]}>("/notifications/history")

    export const sendNotification = (payload: SendPayload): Promise<{ok: boolean, sent: number}> =>
        reqWrite<{ok: boolean, sent: number}>("/notifications/send", {
            method: "POST",
            body:   JSON.stringify(payload),
        })
}
